export const warHeader = {
  title: "Well-Architected",
  title_highlight: "Review",
  paragraph:
    "As an AWS Advanced Tier Partner, TradeSquare runs AWS Well-Architected Framework Reviews to measure your workloads against AWS best practices — surfacing risks across six pillars and giving you a prioritized plan for a more secure, reliable, and cost-efficient cloud.",
};

// `icon` maps to an inline SVG in WellArchitected.js (no external icon font).
export const warPillars = [
  {
    id: "operational-excellence",
    icon: "operations",
    title: "Operational Excellence",
    description:
      "We review how you run and continuously improve workloads day to day — monitoring and observability, automation, runbooks, and change management — so your team can deliver value reliably and learn from every event.",
  },
  {
    id: "security",
    icon: "security",
    title: "Security",
    description:
      "We examine identity and access management, data protection in transit and at rest, detective controls, and incident response — so your security posture is ready for audits, customers, and compliance obligations.",
  },
  {
    id: "reliability",
    icon: "reliability",
    title: "Reliability",
    description:
      "We assess fault tolerance, backup and recovery procedures, and how your architecture absorbs changes in demand — so workloads keep doing what they should and recover quickly when something fails.",
  },
  {
    id: "performance-efficiency",
    icon: "performance",
    title: "Performance Efficiency",
    description:
      "We look at your choice of services, resource sizing, and data access patterns to keep workloads fast and responsive as demand grows — without paying for capacity you don't use.",
  },
  {
    id: "cost-optimization",
    icon: "cost",
    title: "Cost Optimization",
    description:
      "We identify idle or over-provisioned resources, right-sizing opportunities, and pricing models such as Savings Plans and storage tiers — so you pay for what genuinely moves the business.",
  },
  {
    id: "sustainability",
    icon: "sustainability",
    title: "Sustainability",
    description:
      "We review resource utilization along with region and service choices to reduce the energy footprint of your workloads, while keeping performance and cost on track.",
  },
];

export const warProcess = [
  {
    step: "1",
    title: "Scope",
    description: "We define the workload, stakeholders, and the goals for the review.",
  },
  {
    step: "2",
    title: "Review",
    description: "A guided workshop assesses the workload against the six pillars.",
  },
  {
    step: "3",
    title: "Report",
    description: "You receive documented high and medium-risk findings, with context.",
  },
  {
    step: "4",
    title: "Improve",
    description: "We turn the findings into a practical, prioritized remediation roadmap.",
  },
];

export const warCta = {
  heading: "Ready to harden your AWS workloads?",
  text:
    "You get a documented review, a prioritized risk list, and a remediation roadmap. Depending on the workload, the review may also be eligible for AWS funding support toward improvements.",
  buttonLabel: "Book a Well-Architected Review",
  buttonLink: "/contact-us",
};
